import React from "react";

const StarMemo = ({ color }) => {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2329 1.49727C12.0285 0.601774 13.4275 0.601773 14.2232 1.49727L18.0972 5.85758C18.2893 6.07379 18.526 6.24577 18.7909 6.36165L24.135 8.69863C25.2325 9.17859 25.6648 10.5091 25.059 11.5425L22.1093 16.5743C21.963 16.8239 21.8726 17.1021 21.8442 17.3899L21.273 23.1946C21.1557 24.3867 20.0239 25.209 18.8539 24.9522L13.1568 23.7017C12.8743 23.6397 12.5817 23.6397 12.2992 23.7017L6.60219 24.9522C5.43215 25.209 4.30032 24.3867 4.18301 23.1946L3.61181 17.3899C3.58348 17.1021 3.49307 16.8239 3.3468 16.5743L0.397031 11.5425C-0.208778 10.5091 0.223542 9.17859 1.32107 8.69863L6.66511 6.36165C6.9301 6.24577 7.1668 6.07379 7.3589 5.85758L11.2329 1.49727Z"
        fill={color}
      />
    </svg>
  );
};

export default StarMemo;
